<template>
  <div class="page-con">
    <div class="finance-header" style="display: flex; flex-wrap: wrap;margin-bottom: 10px;">
      <span class="finance-span">
        <label>所属公司</label>
        <Select
            v-model="searchInvoiceCompName"
            multiple
            filterable
            prefix="ios-arrow-down"
            :default-label="[]"
            :loading="searchLoading"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            placeholder="输入所属公司"
        >
          <Option v-for="option in invoiceCompNameOptions" :value="option.id"
                  :key="option.name">{{ option.name }}
          </Option>
         </Select>
      </span>
      <span class="finance-span">
        <label>业务员</label>
        <Select
            v-model="searchSalesMan"
            multiple
            filterable
            prefix="ios-arrow-down"
            :default-label="[]"
            :loading="searchLoading"
            :remote-method="(file) =>remoteMethod(file,'salesManOptions','invoiceTwo','queryInvoiceKeyword',4)"
            :max-tag-count="1"
            :max-tag-placeholder="maxTagPlaceholder"
            @on-set-default-options="(file) =>setDefaultOptions(file,'salesManOptions')"
            placeholder="输入业务员"
        >
          <Option v-for="option in salesManOptions" :value="option.id"
                  :key="option.text">{{ option.text }}
          </Option>
        </Select>
      </span>
      <span class="finance-span">
          <label>客户经理</label>
           <Select
               v-model="searchClient"
               multiple
               filterable
               prefix="ios-arrow-down"
               :default-label="[]"
               :loading="searchLoading"
               :remote-method="(file) =>remoteMethod(file,'clientOptions','invoiceTwo','queryInvoiceKeyword',3)"
               :max-tag-count="1"
               :max-tag-placeholder="maxTagPlaceholder"
               @on-set-default-options="(file) =>setDefaultOptions(file,'clientOptions')"
               placeholder="输入客户经理"
           >
            <Option v-for="option in clientOptions" :value="option.id"
                    :key="option.text">{{ option.text }}
            </Option>
          </Select>
      </span>
      <span class="finance-span">
          <label>销售经理</label>
           <Select
               v-model="searchSalesManager"
               multiple
               filterable
               prefix="ios-arrow-down"
               :default-label="[]"
               :loading="searchLoading"
               :remote-method="(file) =>remoteMethod(file,'salesManagerOptions','invoiceTwo','queryInvoiceKeyword',6)"
               :max-tag-count="1"
               :max-tag-placeholder="maxTagPlaceholder"
               @on-set-default-options="(file) =>setDefaultOptions(file,'salesManagerOptions')"
               placeholder="输入销售经理"
               @on-change="onChange"
           >
            <Option v-for="option in salesManagerOptions" :value="option.text"
                    :key="option.text">{{ option.text }}
            </Option>
          </Select>
      </span>
      <span class="finance-span">
          <label>外部销售</label>
           <Select
               v-model="searchSalesManagerOutside"
               multiple
               filterable
               prefix="ios-arrow-down"
               :default-label="[]"
               :loading="searchLoading"
               :remote-method="(file) =>remoteMethod(file,'salesManagerOutsideOptions','invoiceTwo','queryInvoiceKeyword',9)"
               :max-tag-count="1"
               :max-tag-placeholder="maxTagPlaceholder"
               @on-set-default-options="(file) =>setDefaultOptions(file,'salesManagerOutsideOptions')"
               placeholder="输入外部销售"
               @on-change="onChange"
           >
            <Option v-for="option in salesManagerOutsideOptions" :value="option.text"
                    :key="option.text">{{ option.text }}
            </Option>
          </Select>
      </span>
      <span class="finance-span">
          <label>年份</label>
         <DatePicker v-model="year" type="year" placeholder="请选择年份" style="width: 200px"></DatePicker>
       </span>
      <span class="finance-span">
          <label>统计维度</label>
          <Select v-model="dimension">
          <Option value="2">按抵扣日期</Option>
          <Option value="1">按开票日期</Option>
        </Select>
      </span>
      <span class="finance-span">
          <Button type="primary" style="border-radius: 5px" @click="totalAchieve">查询</Button>
          <Button type="primary" style="border-radius: 5px;margin-left: 10px" @click="download"
                  v-if="isHavePermission('totalIncome:import')">导出</Button>
          <Button icon="md-refresh" style="border-radius: 5px;margin-left: 10px" @click="totalAchieve">刷新</Button>
        </span>
    </div>

    <div class="list-box common-shadow">
      <vxe-table
          ref="xTable"
          stripe
          class="table-style"
          align="center"
          highlight-hover-row
          max-height="680"
          border="none"
          :loading="loading"
          show-footer
          :data="tableData"
          :footer-method="footerMethod"
      >
        <vxe-table-column field="id" title="序号" width="100" fixed="left">
          <template slot-scope="{ $rowIndex }">
            <span>{{ $rowIndex + 1 }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="compName" title="所属公司" width="150" show-overflow fixed="left"></vxe-table-column>
        <vxe-table-column field="salesMan" title="业务员" width="120" show-overflow fixed="left"></vxe-table-column>
        <vxe-table-column field="clientManager" title="客户经理" width="120" show-overflow fixed="left"></vxe-table-column>
        <vxe-table-column field="salesManager" title="销售经理" width="120" show-overflow fixed="left"></vxe-table-column>
        <vxe-table-column field="salesManagerOutside" title="外部销售" width="120" show-overflow
                          fixed="left"></vxe-table-column>
        <vxe-table-column field="data1" title="1月份" width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="data2" title="2月份" width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="data3" title="3月份" width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="data4" title="4月份" width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="data5" title="5月份" width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="data6" title="6月份" width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="data7" title="7月份" width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="data8" title="8月份" width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="data9" title="9月份" width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="data10" title="10月份" width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="data11" title="11月份" width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="data12" title="12月份" width="150" show-overflow></vxe-table-column>
        <vxe-table-column field="totalAmount" title="合计" width="150" show-overflow></vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import {getBlob, hideLoading, isEmpty, isNotEmpty, saveBlob, showLoading} from "@/utils/util";
import getAuthOrization from "@/mixin/getAuthOrization";

export default {
  mixins: [getAuthOrization],
  data() {
    return {
      loading: false,
      tableData: [],
      searchSalesMan: [],
      salesManOptions: [],
      searchClient: [],
      searchSalesManager: [],
      salesManagerOptions: [],
      searchInvoiceCompName: [],
      invoiceCompNameOptions: [],
      searchSalesManagerOutside: [],
      salesManagerOutsideOptions: [],
      clientOptions: [],
      searchLoading: false,
      year: null,
      dimension: '2',
    }
  },
  mounted() {
    this.$bus.$on("进项分类汇总", () => {
      this.year = this.$utils.toDateString(new Date(), "yyyy");
      this.totalAchieve();
      this.getCompanyList();
      this.getList('', 'salesManOptions', 'invoiceTwo', 'queryInvoiceKeyword', 4);
      this.getList('', 'clientOptions', 'invoiceTwo', 'queryInvoiceKeyword', 3);
      this.getList('', 'salesManagerOptions', 'invoiceTwo', 'queryInvoiceKeyword', 6);
      this.getList('', 'salesManagerOutsideOptions', 'invoiceTwo', 'queryInvoiceKeyword', 9);
    });
    this.year = this.$utils.toDateString(new Date(), "yyyy");
    this.totalAchieve();
    this.getCompanyList();
    this.getList('', 'salesManOptions', 'invoiceTwo', 'queryInvoiceKeyword', 4);
    this.getList('', 'clientOptions', 'invoiceTwo', 'queryInvoiceKeyword', 3);
    this.getList('', 'salesManagerOptions', 'invoiceTwo', 'queryInvoiceKeyword', 6);
    this.getList('', 'salesManagerOutsideOptions', 'invoiceTwo', 'queryInvoiceKeyword', 9);
    // this.getList('', 'salesManagerOptions', 'invoiceTwo', 'queryInvoiceKeyword', 6);
  },
  methods: {
    async getCompanyList() {
      let params = {
        orderBy: 2,
        page: 1,
        rows: 10000,
      };

      let res = await $api.department.get("listCompany", params);
      this.loading = false;
      if (res.status === 1) {
        this.invoiceCompNameOptions = res.data.rows;
      }
    },
    onChange() {
      const visitedViews = this.$store.state.tagsView.visitedViews;
      visitedViews.map(i => {
        if (i.name === '进项分类汇总') {
          i.path = '/payment2/totalIncome'
        }
      })
    },
    async download() {
      showLoading();
      let res = getBlob("/api/order/twoReport/exportTotalAchieve", {
        year: this.$utils.toDateString(this.year, "yyyy"),
        salesManId: this.searchSalesMan,
        platformCompanyId: this.searchInvoiceCompName,
        type: 1,
        totalType: this.dimension,
      });
      hideLoading();
      await saveBlob("导出进项分类汇总.xls", res.data);
    },
    async totalAchieve() {
      showLoading()
      let res = await $api.twoReport.get("totalAchieve", {
        year: this.$utils.toDateString(this.year, "yyyy"),
        salesManId: this.searchSalesMan,
        platformCompanyId: this.searchInvoiceCompName,
        clientManagerId: this.searchClient,
        type: 1,
        totalType: this.dimension,
      })
      hideLoading()
      this.loading = false
      if (res.status === 1) {
        if (this.searchSalesManager.length > 0 || this.searchSalesManagerOutside.length > 0) {
          let arr1 = [];
          this.searchSalesManager.map(i => {
            res.data.map(j => {
              if (i === j.salesManager) {
                arr1.push(j);
              }
            })
          })
          if (this.searchSalesManagerOutside.length > 0) {
            let arr2 = [];
            this.searchSalesManagerOutside.map(i => {
              res.data.map(j => {
                if (i === j.salesManagerOutside) {
                  arr2.push(j);
                }
              })
            })
            this.tableData = arr2;
          } else {
            this.tableData = arr1;
          }
        } else {
          this.tableData = res.data;
        }
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : '接口异常',
          status: "error",
        });
      }
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        columnType: columnType,
        moduleType: 1
      };

      if (!isEmpty(query)) {
        params.keyword = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        let data = res.data;
        this[options] = [];
        data.map((i, index) => {
          this[options].push(i)
        })
      }
    },
    footerMethod({columns, data}) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["data1", "data2", "data3", "data4", "data5", "data6", "data7", "data8", "data9", "data10", "data11", "data12", 'totalAmount'].includes(column.property)) {
            return this.$utils.sum(data, column.property);
          }
          return null;
        }),
      ];
    },
  }
}

</script>


<style>

</style>